import { useEffect, useState, useRef, useContext, RefObject } from "react";
import { Tab, Nav, Carousel, Card } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { isEmpty } from "lodash";
import VideoContext from "../../store/video-context";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { useMediaQuery } from 'react-responsive';
import MediaQuery from 'react-responsive';
import { BiError } from "react-icons/bi";
import { IoIosArrowDropdown } from "react-icons/io";


const DetailsTab = (props: any) => {
  const vContext = useContext(VideoContext);
  const emptyObj: { [index: string]: any } = {};
  const [tabData, setTabData] = useState(emptyObj);
  const detailsRef = useRef() as RefObject<HTMLInputElement>;

  useEffect(() => {
    setTabData(props.tabData);
    vContext.detailsRefHandler(detailsRef);
  }, []);

  return (
    <>
      {!isEmpty(tabData) && (
        <div
          ref={detailsRef}
          className="surgery-details-section blue-shadow-box mb-3"
        >
          <Tab.Container id="video-details" defaultActiveKey="surgery-details">
          <MediaQuery maxWidth={768}>
              <Nav variant="tabs">
                <Swiper spaceBetween={0} slidesPerView={2.5}>
                  <SwiperSlide>
                    <Nav.Link eventKey="surgery-details">
                    Surgery Literature
                    </Nav.Link>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Nav.Link eventKey="surgery-steps">Surgery Steps</Nav.Link>
                  </SwiperSlide>
                  {tabData.txData[0].surgery_type=="" &&
                  (
                  <SwiperSlide>
                    <Nav.Link eventKey="port-position">{ tabData.txData[0].tx_speciality === "1" ? "Port Position" : "X-ray"}</Nav.Link>
                    {/* <Nav.Link eventKey="port-position">Port Position</Nav.Link> */}
                  </SwiperSlide>
                  )}
                  <SwiperSlide>
                    <Nav.Link eventKey="precautions">Precautions</Nav.Link>
                  </SwiperSlide>
                </Swiper>
              </Nav>
              </MediaQuery>
              <MediaQuery minWidth={769}>
              <Nav variant="tabs">
                <Nav.Link eventKey="surgery-details">Surgery Literature</Nav.Link>
                <Nav.Link eventKey="surgery-steps">Surgery Steps</Nav.Link>
                {tabData.txData[0].surgery_type=="" &&
                  (
                <Nav.Link eventKey="port-position">{ tabData.txData[0].tx_speciality === "1" ? "Port Position" : "X-ray"}</Nav.Link>
                  )}
                <Nav.Link eventKey="precautions">Precautions</Nav.Link>
              </Nav>
        </MediaQuery>

            <Tab.Content className="custom-tab-content">
              <Tab.Pane eventKey="surgery-details">
                <Accordion defaultActiveKey="0">
                  <ul className="surgery-details-list blue-shadow-box accordion mb-0">
                    {/* {console.log('tabData11', tabData)} */}
                    {tabData.prePostMeasures.length === 0 && <div className="tagged-link-notfound">
                          <BiError size={22} /> No details uploaded
                        </div>}
                    {tabData.prePostMeasures.map((item: any, key: any) => (
                      <li key={"details_" + key} >
                        <div>
                        <Accordion.Toggle
                          eventKey={key + item.title}
                          as={Card.Link}
                          
                        >
                     
                          <div
                            className="surgery-details-text surgery-details-title  card-header"
                            id="measure-details"
                          >
                            {item.title}
                        
                            <IoIosArrowDropdown size={22} style={{float:"right",fill: "#0F70B6"}}/>


                          </div>
                    
                        </Accordion.Toggle>
         
                        <Accordion.Collapse eventKey={key + item.title}  as={Card.Body}>
                          {item.description ? (
                            <div
                              className="surgery-details-desc" //dangerouslySetInnerHTML={{__html: item.description}}
                            >
                              {item.description
                                .split(":new:")
                                .map((str: any) => (
                                  <p id="surgery-dets">{str}</p>
                                ))}
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </Accordion.Collapse>
                        </div>
                      </li>
                    ))}
                  </ul>
                </Accordion>
              </Tab.Pane>

              <Tab.Pane eventKey="surgery-steps">
              <Accordion defaultActiveKey="0">
                <ol
                  className="surgery-details-list blue-shadow-box accordion  mb-0"
                  id="surgery-steps-numbering"
                >
                  {tabData.indexsteps.length === 0 && <div className="tagged-link-notfound">
                          <BiError size={22} /> No details uploaded
                        </div>}
                  {tabData.indexsteps.map((item: any) => (
                    <li key={item.id}>
                      <div>
                        <Accordion.Toggle
                          eventKey={item.step_name}
                          as={Card.Link}
                          
                        >
                          
                      <div className="surgery-steps-text surgery-details-title card-header" id="measure-details">
                        {item.step_name}
                        {item.step_desc ? (<IoIosArrowDropdown size={22} style={{float:"right",fill: "#0F70B6"}}/>
                        ):(<div></div>)}
                      </div>
                      </Accordion.Toggle>
                      {/* <br /> */}
                      
                      <Accordion.Collapse eventKey={item.step_name}  as={Card.Body}>
                      {item.step_desc ? (
                        <div className="surgery-details-desc">
                          {item.step_desc.split(":new:").map((str: any) => (
                            <p id="surgery-dets">{str}</p>
                          ))}
                        </div>
                      ) : (
                        <div></div>
                      )}
                      </Accordion.Collapse>
                      </div>
                    </li>
                  ))}
                </ol>
              
              </Accordion>
              
              </Tab.Pane>
              <Tab.Pane eventKey="port-position">
                {/* <ul className="surgery-details-list mb-0"> */}
                <Carousel controls={tabData.port.length > 1 ? true : false}>
                {tabData.port.length === 0 && <div className="tagged-link-notfound">
                          <BiError size={22} /> No details uploaded
                        </div>}
                  {tabData.port.map((item: any, key: any) => (
                    // <li key={'port_' + key}>
                    //   <div className="surgery-details-text">{item.title}</div>
                    // </li>
                    <Carousel.Item interval={5000}>
                      <img
                        className="d-block carousel-img"
                        // src={item.image}
                        src={
                          window.location.hostname == "localhost"
                            ? "https://www.lapguru.com" + "/" + item.image
                            : window.location.origin + "/" + item.image
                        }
                        // src={'https://www.lapguru.com' + '/' + item.image}
                        // src="holder.js/800x400?text=Third slide&bg=20232a"
                        alt={item.title}
                      />
                      <div className="carousel-desc">
                        {item.description ? (
                          <div
                            className="surgery-details-desc"
                            id="carousel-text-tab"
                            style={{ padding: "2em" }}
                          >
                            {item.description.split("\n").map((str: any) => (
                              <p>{str}</p>
                            ))}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
                {/* </ul> */}
              </Tab.Pane>
              <Tab.Pane eventKey="precautions">
              <Accordion defaultActiveKey="0">
              <ul className="surgery-details-list blue-shadow-box accordion mb-0">
                    {/* {console.log('tabData11', tabData)} */}
                    {tabData.pitfalls.length === 0 && <div className="tagged-link-notfound">
                          <BiError size={22} /> No details uploaded
                        </div>}
                    {tabData.pitfalls.map((item: any, key: any) => (
                      <li key={"pitfalls_" + key} >
                        <div>
                        <Accordion.Toggle
                          eventKey={key + item.title}
                          as={Card.Link}
                          
                        >
                     
                          <div
                            className="surgery-details-text surgery-details-title  card-header"
                            id="measure-details"
                          >
                            {item.title}
                        
                            <IoIosArrowDropdown size={22} style={{float:"right",fill: "#0F70B6"}}/>


                          </div>
                    
                        </Accordion.Toggle>
         
                        <Accordion.Collapse eventKey={key + item.title}  as={Card.Body}>
                          {item.description ? (
                            <div
                              className="surgery-details-desc" //dangerouslySetInnerHTML={{__html: item.description}}
                            >
                                {item.description.split("\n").map((str: any) => (
                            <p>{str.replace(".", ". ")}</p>
                          ))}
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </Accordion.Collapse>
                        </div>
                      </li>
                    ))}
                  </ul>

              {/*  
                <ul className="surgery-details-list mb-0">
                {tabData.pitfalls.length === 0 && <div className="tagged-link-notfound">
                          <BiError size={22} /> No details uploaded
                        </div>}
                  {tabData.pitfalls.map((item: any, key: any) => (
                    <li key={"pitfalls_" + key}>
                      <div className="surgery-details-text surgery-details-title  card-header"
                          >{item.title}</div>
                      {console.log("yes",item)}
                      <br />
                      {item.description ? (
                        <div className="surgery-details-desc">
                          {item.description.split("\n").map((str: any) => (
                            <p>{str.replace(".", ". ")}</p>
                          ))}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </li>
                  ))}
                </ul>
                */}
                </Accordion>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      )}
    </>
  );
};

export default DetailsTab;
